// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useHeap as _heap } from "@/use/useHeap";
import { HeapMethods } from "@shared/types/global.ts";
export const getHeapClient: () => HeapMethods = _heap;
